import React from 'react';
import { Facebook, Instagram, Award } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_empire-lawn-quote/artifacts/k10girhv_Empire%20Lawn%20Care%20and%20Maintenance%20logo%202024.png";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo & About */}
          <div>
            <img
              src={LOGO_URL}
              alt="Empire Lawn Care and Maintenance"
              className="h-16 w-auto mb-4 brightness-0 invert"
            />
            <p className="font-inter text-gray-400 text-sm leading-relaxed">
              Professional lawn care and exterior maintenance services in Coffs Harbour. 
              Certified in Horticulture and Park and Gardens.
            </p>
            <div className="flex items-center mt-4 text-amber-500">
              <Award size={18} className="mr-2" />
              <span className="font-inter text-sm">Certified Professionals</span>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-oswald text-lg font-semibold text-white mb-4">
              Our Services
            </h4>
            <ul className="space-y-2 font-inter text-sm text-gray-400">
              <li>Lawn Care</li>
              <li>Garden Maintenance</li>
              <li>Pressure Cleaning</li>
              <li>Solar Panel Clean</li>
              <li>Roof Clean</li>
              <li>House Wash</li>
              <li>Gutter Clean</li>
              <li>Exterior Window Clean</li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h4 className="font-oswald text-lg font-semibold text-white mb-4">
              Get In Touch
            </h4>
            <div className="space-y-3 font-inter text-sm text-gray-400">
              <p>
                <span className="text-white">Lawn Care:</span>{' '}
                <a href="tel:0421441364" className="hover:text-amber-500 transition-colors">
                  0421 441 364
                </a>
              </p>
              <p>
                <span className="text-white">Exterior Cleaning:</span>{' '}
                <a href="tel:0401226517" className="hover:text-amber-500 transition-colors">
                  0401 226 517
                </a>
              </p>
              <p>
                <a
                  href="mailto:empirelawncareandmaintenance@gmail.com"
                  className="hover:text-amber-500 transition-colors break-all"
                >
                  empirelawncareandmaintenance@gmail.com
                </a>
              </p>
            </div>

            {/* Social Links */}
            <div className="flex space-x-4 mt-6">
              <a
                href="https://www.facebook.com/profile.php?id=100087080497238"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 p-3 rounded-full hover:bg-amber-600 transition-colors"
                data-testid="social-facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href="#"
                className="bg-gray-800 p-3 rounded-full hover:bg-amber-600 transition-colors"
                data-testid="social-instagram"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-10 pt-8 text-center">
          <p className="font-inter text-sm text-gray-500">
            &copy; {currentYear} Empire Lawn Care and Maintenance. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
